// based on: https://github.com/bvarta-tech/react-shared-libraries/blob/main/packages/src/components/divider/divider.tsx
import { twMerge } from "tailwind-merge";

export type DividerProps = {
  type?: string;
  className?: string;
  width?: string;
  height?: string;
  lineClassName?: string;
};

export const Divider = ({
  type,
  className,
  height,
  width,
  lineClassName
}: DividerProps) => {
  const heightDivider = {
    height: `${height}`
  };
  const widthtDivider = {
    width: `${width}`
  };
  return type === "vertical" ? (
    <div
      className={twMerge(`relative flex flex-col`, className)}
      style={heightDivider}
    >
      <div
        className={twMerge(
          `flex-grow border-l border-neutral-200`,
          lineClassName
        )}
      ></div>
    </div>
  ) : (
    <div className={twMerge(`relative flex`, className)} style={widthtDivider}>
      <div
        className={twMerge(
          `flex-grow border-t border-neutral-200`,
          lineClassName
        )}
      ></div>
    </div>
  );
};

export default Divider;
